module.exports = __webpack_public_path__ + "img/xmr.22ac5949.svg";